/**
 * Daring Martin — Wishlist (localStorage)
 *
 * Guarda handles de producto en localStorage bajo la clave "dm_wishlist".
 * Cualquier botón con [data-dm-wishlist-toggle] + [data-dm-wishlist-handle="..."]
 * queda enganchado automáticamente vía delegación de eventos en document,
 * así que funciona en botones renderizados dinámicamente (ej. el grid del
 * home) sin necesidad de volver a inicializar nada.
 *
 * Eventos disponibles:
 * - "dm:wishlist:change" (en document) — se dispara cada vez que cambia la
 *   lista. detail: { handle, saved, list }. Lo usa sections/dm-wishlist.liquid
 *   para re-renderizar la página sin recargar.
 *
 * API pública: window.dmWishlist.{read, isSaved, toggle, sync}
 */
(function () {
  var STORAGE_KEY = 'dm_wishlist';

  function readWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
      /* localStorage no disponible (modo privado, storage lleno, etc.) —
         fallamos en silencio, la wishlist simplemente no persiste. */
    }
  }

  function isSaved(handle) {
    if (!handle) return false;
    return readWishlist().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    if (!handle) return false;
    var list = readWishlist();
    var idx = list.indexOf(handle);
    var nowSaved;
    if (idx === -1) {
      list.push(handle);
      nowSaved = true;
    } else {
      list.splice(idx, 1);
      nowSaved = false;
    }
    writeWishlist(list);
    syncButtons();
    document.dispatchEvent(
      new CustomEvent('dm:wishlist:change', {
        detail: { handle: handle, saved: nowSaved, list: list },
      })
    );
    return nowSaved;
  }

  function syncButtons() {
    var list = readWishlist();
    var buttons = document.querySelectorAll('[data-dm-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var handle = btn.getAttribute('data-dm-wishlist-handle');
      var saved = handle ? list.indexOf(handle) !== -1 : false;
      btn.classList.toggle('is-active', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    }
    var headerIcons = document.querySelectorAll('[data-dm-header-wishlist]');
    for (var j = 0; j < headerIcons.length; j++) {
      headerIcons[j].classList.toggle('is-active', list.length > 0);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dm-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-dm-wishlist-handle');
    if (!handle) return;
    toggle(handle);
  });

  function init() {
    syncButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.dmWishlist = {
    read: readWishlist,
    isSaved: isSaved,
    toggle: toggle,
    sync: syncButtons,
  };
})();